import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import "./backoffice.css";
import mainAxios from "../../../redux/api/mainAxios";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../redux/actions/modalActions";
import { getSecteurs } from "../../../redux/actions/promoteursActions";

const AddSecteurComponent = ({}) => {
  const dispatch = useDispatch();
  const [secteurName, setSecteurName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [editingSecteur, setEditingSecteur] = useState(null);
  const { secteurs } = useSelector((state) => state.promoteursReducer);

  useEffect(() => {
    dispatch(getSecteurs());
  }, [dispatch]);

  const handleInputChange = (e) => {
    setSecteurName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!secteurName.trim()) {
      toast.error("Le nom du secteur est obligatoire");
      return;
    }

    setIsLoading(true);

    try {
      if (editingSecteur) {
        // Update existing secteur
        await mainAxios.put(`/api/secteurs/${editingSecteur.documentId}`, {
          data: {
            name: secteurName.trim(),
          },
        });

        toast.success("Secteur mis à jour avec succès");
        setEditingSecteur(null);
      } else {
        // Check if secteur already exists when creating new
        const secteurExists = secteurs?.data?.some(
          (secteur) =>
            secteur.name.toLowerCase() === secteurName.trim().toLowerCase()
        );

        if (secteurExists) {
          toast.error("Ce secteur existe déjà");
          setIsLoading(false);
          return;
        }

        // Create new secteur
        await mainAxios.post(`/api/secteurs`, {
          data: {
            name: secteurName.trim(),
          },
        });

        toast.success("Secteur ajouté avec succès");
      }

      setSecteurName("");
      // Refresh secteurs list
      dispatch(getSecteurs());
    } catch (error) {
      console.error("Erreur lors de l'opération sur le secteur:", error);
      toast.error(
        editingSecteur
          ? "Erreur lors de la mise à jour du secteur"
          : "Erreur lors de l'ajout du secteur"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteSecteur = async (id) => {
    try {
      setDeleteLoading(id);

      // Check if the secteur is associated with any users or promoteur_accesses
      /*   const secteurToDelete = secteurs.data.find((s) => s.id === id);

      if (
        secteurToDelete?.attributes?.users?.data?.length > 0 ||
        secteurToDelete?.attributes?.promoteur_accesses?.data?.length > 0
      ) {
        toast.error(
          "Ce secteur est associé à des utilisateurs ou des promoteurs et ne peut pas être supprimé"
        );
        return;
      } */

      await mainAxios.delete(`/api/secteurs/${id}`);
      toast.success("Secteur supprimé avec succès");

      // If we were editing this secteur, clear the form
      if (editingSecteur && editingSecteur.id === id) {
        setEditingSecteur(null);
        setSecteurName("");
      }

      // Refresh secteurs list
      dispatch(getSecteurs());
    } catch (error) {
      console.error("Erreur lors de la suppression du secteur:", error);
      toast.error("Erreur lors de la suppression du secteur");
    } finally {
      setDeleteLoading(null);
    }
  };

  const handleEditSecteur = (secteur) => {
    setEditingSecteur(secteur);
    setSecteurName(secteur.name);
  };

  return (
    <div className="d-flex flex-column gap20">
      <form
        onSubmit={handleSubmit}
        className="edit-collaborator-form d-flex flex-column"
      >
        <div className="form-group">
          <label className="mb-10">
            {editingSecteur ? "Modifier le secteur" : "Nom du secteur"}
          </label>
          <input
            type="text"
            name="name"
            value={secteurName}
            onChange={handleInputChange}
            className="form-control"
            placeholder={
              editingSecteur
                ? "Modifier le nom du secteur"
                : "Entrez le nom du secteur"
            }
            required
          />
        </div>

        <div className="form-actions d-flex gap-3">
          <button
            type="submit"
            className={`border-0 radius5 px-20 py-10 white hoverOpacity ${
              isLoading || !secteurName.trim()
                ? "bg-soft-grey cursor-not-allowed"
                : "bg-pink cursor-pointer"
            }`}
            disabled={isLoading || !secteurName.trim()}
          >
            {isLoading
              ? editingSecteur
                ? "Mise à jour..."
                : "Ajout en cours..."
              : editingSecteur
              ? "Mettre à jour"
              : "Valider"}
          </button>
          {editingSecteur && (
            <button
              type="button"
              className="ms-2 border-0 bg-light radius5 px-2 py-1"
              onClick={() => {
                setEditingSecteur(null);
                setSecteurName("");
              }}
            >
              Annuler
            </button>
          )}
        </div>
      </form>

      {/* Liste des secteurs existants */}
      <div className="mt-20">
        <h3 className="mb-10">Secteurs existants</h3>
        <div
          className="secteurs-list"
          style={{ maxHeight: "250px", overflowY: "auto" }}
        >
          {secteurs?.data?.length > 0 ? (
            <div className="d-flex flex-column gap-2">
              {secteurs.data.map((secteur) => (
                <div
                  key={secteur.id}
                  className="secteur-item d-flex justify-content-between align-items-center bg-light radius5 px-2 py-1 w100"
                  style={{ border: "1px solid #eee" }}
                >
                  <span className="me-2" style={{ fontSize: "14px" }}>
                    {secteur.name}
                  </span>
                  <div className="d-flex">
                    <button
                      type="button"
                      onClick={() => handleEditSecteur(secteur)}
                      className={`border-0 radius5 me-1 d-flex align-items-center justify-content-center bg-primary cursor-pointer`}
                      style={{ width: "20px", height: "20px", padding: 0 }}
                      disabled={editingSecteur?.id === secteur.id}
                      title="Modifier"
                    >
                      <span
                        style={{
                          color: "white",
                          fontSize: "10px",
                          lineHeight: 1,
                        }}
                      >
                        ✎
                      </span>
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeleteSecteur(secteur.id)}
                      className={`border-0 radius5 d-flex align-items-center justify-content-center ${
                        deleteLoading === secteur.id
                          ? "bg-soft-grey"
                          : "bg-danger"
                      } cursor-pointer`}
                      style={{ width: "20px", height: "20px", padding: 0 }}
                      disabled={deleteLoading === secteur.id}
                      title="Supprimer"
                    >
                      {deleteLoading === secteur.id ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          style={{ width: "10px", height: "10px" }}
                        ></span>
                      ) : (
                        <span
                          style={{
                            color: "white",
                            fontSize: "14px",
                            lineHeight: 1,
                          }}
                        >
                          ×
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>Aucun secteur disponible</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddSecteurComponent;
